import React, { useEffect, useState } from 'react';
import { ILocation, VehicleTrackingMap } from './VehicleTrackingMap';
import { useSelector } from 'react-redux';
import { socket } from '../../utils/socket';
import { SOCKET_EVENTS } from '../views/utils';
import { IAppState } from '../../store';
import { Paper, Typography, Box } from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { useLazyQuery, useMutation } from '@apollo/client';
import { GET_ESTIMATED_TIME_ARRIVAL } from '../../graphql/bookings/getEstimatedTimeArrival';

interface MapSectionProps {
  jobId: string;
  lastKnownDriverLocation: ILocation | null;
  customerLocation: ILocation | null;
}

const MapSection: React.FC<MapSectionProps> = ({ jobId, lastKnownDriverLocation,customerLocation }) => {
  const [eta, setEta] = useState<string | null>(null);
  const [distance, setDistance] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const authUser = useSelector((state: IAppState) => state.authReducer.authUser);

  const [getJobEstimatedTimeArrival] = useMutation(GET_ESTIMATED_TIME_ARRIVAL, {
    onCompleted: (data) => {
      if (data.getJobEstimatedTimeArrival) {
        setEta(data.getJobEstimatedTimeArrival.duration);
        setDistance(data.getJobEstimatedTimeArrival.distance);
      } else {
        setEta(null);
        setDistance(null);
      }
    },
    onError: (error) => {
      console.error('Error fetching ETA:', error);
      setError(error.message);
    },
  });

  useEffect(() => {
    if (jobId) {
      getJobEstimatedTimeArrival({ variables: { jobId } });
    }

  }, [jobId]);
  
  const parseMinutes = (duration: string | null): number | null => {
    if (!duration) return null;
    const match = duration.match(/(\d+)\s*min/);
    return match ? parseInt(match[1], 10) : null;
  };

  const minutes = parseMinutes(eta);

  return (
    <Paper elevation={3} style={{ padding: 16 }}>
      <Typography variant="h6" component="div" style={{ marginBottom: 16 }}>
        Vehicle Tracking
      </Typography>
      {(!error && eta && minutes !== null && minutes < 15) ? (
        <Box
          style={{
            position: 'relative',
            height: 256,
            width: '100%',
            marginBottom: 16,
            backgroundColor: '#f0f0f0',
            border: '1px solid #ccc',  
          }}
        >
          <VehicleTrackingMap
            driverLocation={lastKnownDriverLocation}
            customerLocation={customerLocation}
          />
        </Box>
      ) : (
        <Typography variant="body2" style={{ marginBottom: 16 }} color="textSecondary">
          Live location tracking data will be displayed here once available.
        </Typography>
      )}
      {(!error && eta) ? (
        <>
          <Box style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
            <AccessTimeIcon fontSize="small" color="primary" />
            <Typography variant="body1">
              Estimated Arrival: {eta || 'Calculating...'}
            </Typography>
          </Box>
    
        </>
      ) : null}
    </Paper>
  );
};

export default MapSection;
